import React from 'react';
import { useTranslation } from 'react-i18next';
import TableGrid, { Body, Cell, Head, Row } from 'layout/atoms/TableGrid';
const COLUMNS = [
    ['80px', '1fr'],
    ['120px', '2fr'],
    ['80px', '1fr'],
    ['120px', '2fr'],
    ['100px', '1fr'],
    ['100px', '1fr'],
    ['100px', '1fr'],
    ['60px', '60px'],
];
function WarehouseReleasesList({ children }) {
    const { t } = useTranslation(['common', 'warehouseReleases']);
    return (React.createElement(TableGrid, { columns: COLUMNS, rowBorders: true, columnBorders: true },
        React.createElement(Head, null,
            React.createElement(Row, { head: true },
                React.createElement(Cell, { align: "left" }, t('warehouseReleases:number')),
                React.createElement(Cell, { align: "left" }, t('warehouseReleases:specification')),
                React.createElement(Cell, { align: "left" }, t('warehouseReleases:volume_total')),
                React.createElement(Cell, { align: "left" }, t('warehouseReleases:receiver')),
                React.createElement(Cell, { align: "left" }, t('status')),
                React.createElement(Cell, { align: "left" }, t('created_date')),
                React.createElement(Cell, { align: "left" }, t('modified_date')),
                React.createElement(Cell, null))),
        React.createElement(Body, null, children)));
}
export default WarehouseReleasesList;
